<script setup lang="ts">
import Modal from '@/components/modals/Modal.vue'
import useRateLimitingModal from '@/composables/useRateLimitingModal'
import { useI18n } from 'vue-i18n'

const { rateLimitingModal } = useRateLimitingModal()
const { t } = useI18n()
</script>

<template>
  <Modal id="rate-limiting-modal" ref="rateLimitingModal" :title="t('Free version exceeded')">
    <div class="d-flex bg-gradient-dark-green-helper rounded-3">
      <img src="/img/robot.png" height="100" />
      <span class="m-3 ms-1 text-white 2">
        {{ t('If you want to process more documents, you can contact the sales team for an offer') }}:

        <a href="mailto:saifty-sales@coac.de" target="_blank" class="fw-bold d-block text-white">
          saifty-sales@coac.de
        </a>
      </span>
    </div>
  </Modal>
</template>
